module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 3-w720.13a98135.jpg";